export default function loadingReducer(state = {}, action) {
  const { type, payload } = action;
  const error = (payload !== undefined && payload !== null) ? payload : { status: 0 };
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);
  const { status } = error;
  if (!matches) return state;

  const [, requestName, requestState] = matches;
  let success = null;
  if (requestState === 'SUCCESS') success = true;
  if (requestState === 'FAILURE') success = false;
  const response = payload && payload.response ? payload.response : null;
  return {
    ...state,
    [requestName]: {
      running: requestState === 'REQUEST',
      success,
      httpCode: status,
      response,
    },
  };
}
